import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useLocaleStore, type SupportedLocale } from '@/stores/localeStore';

interface LocaleOption {
  value: SupportedLocale;
  label: string;
}

const LOCALE_OPTIONS: LocaleOption[] = [
  { value: 'hy', label: 'Հայ' },
  { value: 'ru', label: 'Рус' },
  { value: 'en', label: 'Eng' },
];

interface LocaleSwitcherProps {
  /** header — compact, dark nav background. header-light — compact, white nav background. auth — larger, for login page. */
  variant?: 'header' | 'header-light' | 'auth';
}

export function LocaleSwitcher({ variant = 'header' }: LocaleSwitcherProps) {
  const { t } = useTranslation('common');
  const locale = useLocaleStore((s) => s.locale);
  const setLocale = useLocaleStore((s) => s.setLocale);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setLocale(e.target.value as SupportedLocale);
  };

  return (
    <select
      value={locale}
      onChange={handleChange}
      aria-label={t('actions.selectLanguage')}
      className={clsx(
        'rounded-md border font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2',
        variant === 'header' && [
          'border-slate-600 bg-slate-700 text-slate-200 text-xs px-2 py-1',
          'hover:border-slate-500 hover:bg-slate-600',
          'focus:ring-offset-slate-800',
        ],
        variant === 'header-light' && [
          'border-gray-200 bg-white text-gray-700 text-xs px-2 py-1',
          'hover:border-gray-300 hover:bg-gray-50',
        ],
        variant === 'auth' && [
          'border-gray-300 bg-white text-gray-700 text-sm px-3 py-1.5',
          'hover:border-gray-400',
        ],
      )}
    >
      {LOCALE_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
